import script from "./compGroupDetailPostsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupDetailPostsTable.vue?vue&type=script&setup=true&lang=js"

import "./compGroupDetailPostsTable.vue?vue&type=style&index=0&id=0f028d4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f028d4a"]])

export default __exports__